import {formatArrayToStringDisplay, formatDateToAPP} from "../../utils/tools";
import dayjs from "dayjs";


function getQuittanceLigneMontant(quittancesLignes, id) {
	const ligne = quittancesLignes.find(
		(ligne) => ligne.quittance_ligne_rubrique.rubrique_id === id
	);
	return ligne ? parseFloat(ligne.quittance_ligne_montant).toFixed(2) : parseFloat(0).toFixed(2);
}

function getLocationLigneMontant(locationLignes, id) {
	const ligne = locationLignes.find((ligne) => ligne.location_ligne_rubrique.rubrique_id === id);
	return ligne ? parseFloat(ligne.location_ligne_montant).toFixed(2) : parseFloat(0).toFixed(2);
}

function getAllDates(debut, fin) {
	const dates = [];
	let start = dayjs(debut, "YYYY-MM-DD");
	while (start.isBefore(dayjs(fin, "YYYY-MM-DD"))) {
		dates.push(start);
		start = start.add(1, "day");
	}
	return dates;
}

function getNuites(lot, dateDebut, dateFin) {
	const tarifLignes = [];

	const dates = getAllDates(dateDebut, dateFin);

	lot &&
	dates.forEach((date) => {
		const special = lot.lot_nuites?.filter((nuite) =>
			dayjs(date, "DD/MM/YYYY").isBetween(
				dayjs(nuite.nuite_date_debut, "YYYY-MM-DD"),
				dayjs(nuite.nuite_date_fin, "YYYY-MM-DD"),
				null,
				"[]"
			)
		);

		if (special?.length > 0) {
			special.forEach((nuite) => {
				const foundIndex = tarifLignes.findIndex(
					(x) => x.location_ligne_rubrique_id === nuite.nuite_rubrique.rubrique_id
				);

				if (foundIndex !== -1 && nuite.nuite_rubrique.rubrique_montant_fixe === false)
					tarifLignes[foundIndex].location_ligne_montant += parseInt(nuite.nuite_montant);
				else if (foundIndex === -1) {
					const tarifLigne = {
						// location_ligne_location_id: this.props.location.location_id,
						location_ligne_pourcentage_acompte: 0,
						location_ligne_montant: parseFloat(nuite.nuite_montant),
						location_ligne_rubrique_id: nuite.nuite_rubrique.rubrique_id,
						location_ligne_permanente: false,
					};
					tarifLignes.push(tarifLigne);
				}
			});
		} else {
			lot.lot_prix_base
				?.filter((prixBase) => !prixBase.prix_base_proprietaire)
				.forEach((prixBase) => {
					const foundIndex = tarifLignes.findIndex(
						(x) => x.location_ligne_rubrique_id === prixBase.prix_base_rubrique.rubrique_id
					);
					if (foundIndex !== -1 && prixBase.prix_base_rubrique.rubrique_montant_fixe === false)
						tarifLignes[foundIndex].location_ligne_montant += parseInt(
							prixBase.prix_base_montant
						);
					else if (foundIndex === -1) {
						const tarifLigne = {
							// location_ligne_location_id: this.props.location.location_id,
							location_ligne_pourcentage_acompte: 0,
							location_ligne_montant: parseFloat(prixBase.prix_base_montant),
							location_ligne_rubrique_id: prixBase.prix_base_rubrique.rubrique_id,
							location_ligne_permanente: false,
						};
						tarifLignes.push(tarifLigne);
					}
				});
		}
	});
	return tarifLignes;
}

function getMapObjPro(proprietaire) {
	return {
		"#proprietaire_qualite":
			proprietaire.proprietaire_personne.personne_qualite &&
			proprietaire.proprietaire_personne.personne_qualite.qualite_libelle_long,
		"#proprietaire_nom": proprietaire && proprietaire.proprietaire_personne.personne_nom,
		"#proprietaire_prenom": proprietaire.proprietaire_personne.personne_prenom
			? proprietaire.proprietaire_personne.personne_prenom
			: "",
		"#proprietaire_adresse": proprietaire.proprietaire_personne.personne_adresse.adresse_ville,
	};
}

function getMapObjData(data) {
	return {
		"#proprietaire_qualite": data.personne_qualite?.qualite_libelle,
		"#proprietaire_nom": data.personne_nom,
		"#proprietaire_prenom": data.personne_prenom,
		"#personne_tel1": data.personne_tel1,
		"#personne_tel2": data.personne_tel2,
		"#personne_portable1": data.personne_portable1,
		"#personne_portable2": data.personne_portable2,
		"#personne_email1": data.personne_email1,
		"#personne_email2": data.personne_email2,
		"#proprietaire_adresse": data.personne_adresse?.adresse_gmaps_adresse,
	};
}

function getMapObjLoc(locataire) {
	return {
		"#locataire_qualite":
			locataire?.locataire_personne?.personne_qualite &&
			locataire?.locataire_personne?.personne_qualite?.qualite_libelle_long,
		"#locataire_nom": locataire?.locataire_personne?.personne_nom,
		"#locataire_prenom": locataire?.locataire_personne?.personne_prenom
			? locataire?.locataire_personne?.personne_prenom
			: "",
		"#locataire_adresse": locataire?.locataire_personne?.personne_adresse?.adresse_ville,
		"#locataire_pays": locataire?.locataire_personne?.personne_adresse?.adresse_pays,
	};
}

function getMapObjLot(lots, lotSimple, langueId, dateDebut, dateFin) {

	const lotFound = lots.find((lot) => lot.lot_id === lotSimple.lot_id);
	const lot = lotFound ? lotFound : lotSimple;

	const lignes = getNuites(lot, dateDebut, dateFin);
	const total = lignes.reduce((a, b) => a + parseFloat(b.location_ligne_montant), 0);

	const description = lot.lot_descriptions.find(
		(description) => description && description.description_langue.langue_id === langueId
	);

	let champ_perso_3415 = lot.lot_champs_persos?.find(
		(element) => element.lot_champ_perso_champ_perso.champ_perso_id === 3415
	);

	let champ_perso_3416 = lot.lot_champs_persos?.find(
		(element) => element.lot_champ_perso_champ_perso.champ_perso_id === 3416
	);

	let champ_perso_3417 = lot.lot_champs_persos?.find(
		(element) => element.lot_champ_perso_champ_perso.champ_perso_id === 3417
	);

	let champ_perso_3418 = lot.lot_champs_persos?.find(
		(element) => element.lot_champ_perso_champ_perso.champ_perso_id === 3418
	);

	let champ_perso_3419 = lot.lot_champs_persos?.find( // PDL
		(element) => element.lot_champ_perso_champ_perso.champ_perso_id === 3419
	);

	let champ_perso_3434 = lot.lot_champs_persos?.find(
		(element) => element.lot_champ_perso_champ_perso.champ_perso_id === 3434
	);

	let champ_perso_3438 = lot.lot_champs_persos?.find(
		(element) => element.lot_champ_perso_champ_perso.champ_perso_id === 3438
	);

	let champ_perso_3719 = lot.lot_champs_persos?.find(
		(element) => element.lot_champ_perso_champ_perso.champ_perso_id === 3719
	);

	let champ_perso_3720 = lot.lot_champs_persos?.find(
		(element) => element.lot_champ_perso_champ_perso.champ_perso_id === 3720
	);

	let champ_perso_3904 = lot.lot_champs_persos?.find(
		(element) => element.lot_champ_perso_champ_perso.champ_perso_id === 3904 // Branche form-mail Lien Glam
	);

	let champ_perso_3907 = lot.lot_champs_persos?.find(
		(element) => element.lot_champ_perso_champ_perso.champ_perso_id === 3907
	);

	let champ_perso_3910 = lot.lot_champs_persos?.find(
		(element) => element.lot_champ_perso_champ_perso.champ_perso_id === 3910
	);

	let blocMatrice = "";
	lot.lot_matrice?.matrice_ligne.forEach((ligne) => {
		blocMatrice += `${ligne.matrice_ligne_rubrique.rubrique_libelle} : ${parseFloat(
			ligne.matrice_ligne_montant_mois
		).toLocaleString("fr-FR", { style: "currency", currency: "EUR" })}<br />`;
	});


	// On génère un objet avec les champs persos
	const result = lot.lot_champs_persos.reduce((acc, item) => {
		const id = item.lot_champ_perso_champ_perso.champ_perso_id;
		const libelle = item.lot_champ_perso_champ_perso.champ_perso_libelle;
		acc[`#lot_champ_perso_${id}`] = libelle;
		return acc;
	}, {});

	return {
		"#lot_reference": lot.lot_reference,
		"#lot_designation": lot.lot_designation,
		"#lot_code_porte": lot.lot_code_porte ? lot.lot_code_porte : "",
		"#lot_type_lot": lot.lot_type_lot ? lot.lot_type_lot.type_lot_libelle : '',
		"#lot_surface": lot.lot_surface ? lot.lot_surface : "",
		"#lot_etage": lot.lot_etage ? lot.lot_etage : "",
		"#lot_couchages": lot.lot_couchage ? lot.lot_couchage : "",
		"#lot_url": description ? description.description_lot_url : "",
		"#lot_adresse": lot.lot_adresse.adresse_gmaps_adresse,
		"#lot_numero": lot.lot_adresse.adresse_numero,
		"#lot_voie": lot.lot_adresse.adresse_voie,
		"#lot_cp": lot.lot_adresse.adresse_code_postal,
		"#lot_ville": lot.lot_adresse.adresse_ville,
		"#lot_departement": lot.lot_adresse.adresse_departement
			? lot.lot_adresse.adresse_departement
			: "",
		"#lot_pays": lot.lot_adresse.adresse_pays ? lot.lot_adresse.adresse_pays : "",
		"#lot_situation": lot.lot_adresse.adresse_situation,
		"#lot_equipements": formatArrayToStringDisplay(lot.lot_equipements, true),
		"#lot_quartiers": formatArrayToStringDisplay(lot.lot_quartiers, false),
		"#lot_metros": formatArrayToStringDisplay(lot.lot_metros, false),
		"#lot_depot_garantie": parseFloat(lot.lot_depot_garantie),
		"#lot_total_prix": parseFloat(total).toFixed(2),
		...result,
		"#champ_perso_3415": champ_perso_3415 ? champ_perso_3415.lot_champ_perso_valeur : "",
		"#champ_perso_3416": champ_perso_3416 ? champ_perso_3416.lot_champ_perso_valeur : "",
		"#champ_perso_3417": champ_perso_3417 ? champ_perso_3417.lot_champ_perso_valeur : "",
		"#champ_perso_3418": champ_perso_3418 ? champ_perso_3418.lot_champ_perso_valeur : "",
		"#champ_perso_3419": champ_perso_3419 ? champ_perso_3419.lot_champ_perso_valeur : "", //PDL
		"#champ_perso_3434": champ_perso_3434 ? champ_perso_3434.lot_champ_perso_valeur : "",
		"#champ_perso_3438": champ_perso_3438 ? champ_perso_3438.lot_champ_perso_valeur : "",
		"#champ_perso_3719": champ_perso_3719 ? champ_perso_3719.lot_champ_perso_valeur : "",
		"#champ_perso_3720": champ_perso_3720 ? champ_perso_3720.lot_champ_perso_valeur : "",
		"#champ_perso_3904": champ_perso_3904 ? champ_perso_3904.lot_champ_perso_valeur : "",
		"#champ_perso_3907": champ_perso_3907 ? champ_perso_3907.lot_champ_perso_valeur : "",
		"#champ_perso_3910": champ_perso_3910 ? champ_perso_3910.lot_champ_perso_valeur : "",
		"#lot_bloc_matrice": blocMatrice,
	};
}

function fusionChamps(obj, text) {
	let request = new RegExp(Object.keys(obj).join("|"), "gi");
	return text?.replace(request, function (matched) {
		return obj[matched.toLowerCase()];
	});
}

export function onSelectTemplate(bdd, templateSelected, langueId) {
	const {
		lots,
		requete,
		//templatesLangues,
		requetesLots,
		location,
		locationQuittances,
		locationReglements,
		rubriques
	} = bdd;

	let text = templateSelected;

	// Boucler sur les lots liés à la requête si le texte contient une liste sur laquelle boucler
	if (requete && requete !== undefined) {
		let blocBoucleSelection = "";
		let blocOriginalSelection = "";

		let blocBouclePanier = "";
		let blocOriginalPanier = "";

		if (text?.includes("#debut_selection") && text?.includes("#fin_selection")) {
			let part = text.substring(
				text.lastIndexOf("#debut_selection") + 16,
				text.lastIndexOf("#fin_selection")
			);

			blocOriginalSelection = part;

			let requeteLotsSelection = requetesLots.filter(
				(item) =>
					item.requete_lot_requete.requete_id === requete.requete_id &&
					item.requete_lot_type === 1
			);

			requeteLotsSelection &&
			requeteLotsSelection.forEach((i) => {
				const lot = i.requete_lot_lot;
				// const recherche = requete.requete_recherche;

				part = fusionChamps(
					getMapObjLot(lots, lot, langueId, i.requete_lot_date_debut, i.requete_lot_date_fin),
					part
				);
				const proprietaire = lot.lot_proprietaire;
				part = fusionChamps(getMapObjPro(proprietaire), part);

				blocBoucleSelection = blocBoucleSelection + part;
				part = blocOriginalSelection;
			});
		}

		if (text?.includes("#debut_panier") && text?.includes("#fin_panier")) {
			let part = text.substring(
				text.lastIndexOf("#debut_panier") + 13,
				text.lastIndexOf("#fin_panier")
			);

			blocOriginalPanier = part;

			let requeteLotsPanier = requetesLots.filter(
				(item) =>
					item.requete_lot_requete.requete_id === requete.requete_id &&
					item.requete_lot_type === 2
			);

			requeteLotsPanier &&
			requeteLotsPanier.forEach((i) => {
				const lot = i.requete_lot_lot;
				// const recherche = requete.requete_recherche;

				part = fusionChamps(
					getMapObjLot(lots, lot, langueId, i.requete_lot_date_debut, i.requete_lot_date_fin),
					part
				);
				const proprietaire = lot.lot_proprietaire;
				part = fusionChamps(getMapObjPro(proprietaire), part);

				blocBouclePanier = blocBouclePanier + part;
				part = blocOriginalPanier;
			});
		}

		text = text?.replace(blocOriginalSelection, blocBoucleSelection);
		text = text?.replaceAll("#debut_selection", "").replaceAll("#fin_selection", "");

		text = text?.replace(blocOriginalPanier, blocBouclePanier);
		text = text?.replaceAll("#debut_panier", "").replaceAll("#fin_panier", "");
	}

	const locataire = requete?.requete_locataire;
	text = fusionChamps(getMapObjLoc(locataire), text);

	const requeteLot = requetesLots?.find(
		(rl) =>
			location &&
			rl.requete_lot_lot.lot_id === location.location_lot.lot_id &&
			rl.requete_lot_requete.requete_id === requete.requete_id
	);

	if (location && location !== undefined) {
		const lot = location.location_lot;
		text = fusionChamps(
			getMapObjLot(lots, lot, langueId, location.location_date_debut, location.location_date_fin),
			text
		);

		const proprietaire = lot.lot_proprietaire;
		text = fusionChamps(getMapObjPro(proprietaire), text);

		let quittancesLignes = [];
		let datePaiementAttendu = null;
		if (locationQuittances && locationQuittances.length > 0) {
			const lastQuittance = locationQuittances.slice(-1);
			datePaiementAttendu = lastQuittance[0].quittance_date_paiement;
			lastQuittance[0].quittance_ligne.forEach((ligne) => {
				quittancesLignes.push(ligne);
			});
		}

		let reglementsLignes = [];
		if (locationReglements && locationReglements.length > 0) {
			locationReglements.forEach((reglement) => {
				reglement.reglement_ligne.forEach((ligne) => {
					reglementsLignes.push(ligne);
				});
			});
		}

		let tarif = 0;
		let total = 0;
		let regle = 0;
		let solde = 0;
		let fraisDossier = 0;
		let taxeSejour = 0;
		let totalHorsFraisDossier = 0;
		let totalHorsTaxeEtFraisDossier = 0;
		let totalPermanente = 0;

		tarif = location.location_ligne.reduce((a, b) => a + parseFloat(b.location_ligne_montant), 0);

		let blocQuittance = "";
		quittancesLignes.forEach((ligne) => {
			total += parseFloat(ligne.quittance_ligne_montant);
			if (ligne.quittance_ligne_rubrique.rubrique_code === "07") {
				fraisDossier = parseFloat(ligne.quittance_ligne_montant);
			}
			if (ligne.quittance_ligne_rubrique.rubrique_taxe_de_sejour === 1) {
				taxeSejour = parseFloat(ligne.quittance_ligne_montant);
			}
			blocQuittance += `${ligne.quittance_ligne_rubrique.rubrique_libelle} : ${parseFloat(
				ligne.quittance_ligne_montant
			).toLocaleString("fr-FR", { style: "currency", currency: "EUR" })}<br />`;
		});

		let blocTarif = "";
		location.location_ligne.forEach((ligne) => {
			blocTarif += `${ligne.location_ligne_rubrique.rubrique_libelle} : ${parseFloat(
				ligne.location_ligne_montant
			).toLocaleString("fr-FR", { style: "currency", currency: "EUR" })}<br />`;
		});

		let blocTarifPermanente = "";
		location.location_ligne
			.filter((ligne) => ligne.location_ligne_permanente)
			.forEach((ligne) => {
				totalPermanente += parseFloat(ligne.location_ligne_montant);
				blocTarifPermanente += `${ligne.location_ligne_rubrique.rubrique_libelle} : ${parseFloat(
					ligne.location_ligne_montant
				).toLocaleString("fr-FR", { style: "currency", currency: "EUR" })}<br />`;
			});

		const montantNet = quittancesLignes
			? quittancesLignes
				.filter((ligne) => ligne.quittance_ligne_rubrique.rubrique_type === "P")
				.reduce((a, b) => {
					let sum = 0;
					b.quittance_ligne_rubrique.rubrique_signe === "-"
						? (sum = a - parseFloat(b.quittance_ligne_montant))
						: (sum = a + parseFloat(b.quittance_ligne_montant));
					return sum;
				}, 0)
			: 0;

		reglementsLignes.forEach((ligne) => {
			regle += parseFloat(ligne.reglement_ligne_montant);
		});

		solde = total - regle;
		totalHorsFraisDossier = total - fraisDossier;
		totalHorsTaxeEtFraisDossier = total - taxeSejour - fraisDossier;

		let mapObjLaLoc = {
			"#location_id": location.location_id,
			"#location_lot_reference": location.location_lot.lot_reference,
			"#location_date_debut": formatDateToAPP(location.location_date_debut),
			"#location_date_fin": formatDateToAPP(location.location_date_fin),
			"#location_nombre_adultes": location.location_nb_adultes,
			"#location_nombre_enfants": location.location_nb_enfants,
			"#location_nombre_bebes": location.location_nb_bebes,
			"#location_nombre_nuits": dayjs(location.location_date_fin).diff(
				dayjs(location.location_date_debut),
				"days"
			),
			"#location_desiderata": location.location_desiderata,
			"#location_frais_dossier": parseFloat(fraisDossier).toFixed(2),
			"#location_taxe_sejour": parseFloat(taxeSejour).toFixed(2),
			"#location_total_hors_frais_dossier": parseFloat(totalHorsFraisDossier).toFixed(2),
			"#location_total_hors_taxe_et_frais_dossier": parseFloat(totalHorsTaxeEtFraisDossier).toFixed(2),
			"#location_total_prix": parseFloat(total).toFixed(2),
			"#location_deja_regle": parseFloat(regle).toFixed(2),
			"#location_solde": parseFloat(solde).toFixed(2),
			"#location_tarif": parseFloat(tarif).toFixed(2),
			"#location_montant_net": parseFloat(montantNet).toFixed(2),
			"#location_date_acompte": formatDateToAPP(dayjs(location.location_date_debut).subtract(6, "month")),
			"#location_date_solde": formatDateToAPP(dayjs(location.location_date_debut).subtract(30, "days")),
			"#location_bloc_quittance": blocQuittance,
			"#location_bloc_tarif": blocTarif,
			"#date_paiement_attendu": datePaiementAttendu
				? dayjs(datePaiementAttendu).format("DD/MM/YYYY")
				: "",
			"#location_provenance": location.location_requete?.requete_provenance
				? location.location_requete.requete_provenance.provenance_libelle
				: "",
			"#location_groupe": "",
			"#location_montant_plateforme": parseFloat(location.location_montant_plateforme).toFixed(2),
			"#location_bloc_permanente": blocTarifPermanente,
			"#location_total_permanente": parseFloat(totalPermanente).toFixed(2),
		};
		text = fusionChamps(mapObjLaLoc, text);

		const mapObjRub = {};
		const mapObjLocationRub = {};
		const mapObjQuittanceRub = {};
		rubriques.forEach((rubrique) => {
			mapObjRub[`#rubrique_libelle_${rubrique.rubrique_id}`] = rubrique.rubrique_libelle;
			mapObjLocationRub[`#location_rubrique_${rubrique.rubrique_id}`] =
				getLocationLigneMontant(location.location_ligne, rubrique.rubrique_id);
			mapObjQuittanceRub[`#quittance_rubrique_${rubrique.rubrique_id}`] =
				getQuittanceLigneMontant(quittancesLignes, rubrique.rubrique_id);
		});

		text = fusionChamps(mapObjRub, text);
		text = fusionChamps(mapObjLocationRub, text);
		text = fusionChamps(mapObjQuittanceRub, text);
	} else {
		if (requeteLot && requeteLot !== undefined) {
			const lot = requeteLot.requete_lot_lot;
			text = fusionChamps(
				getMapObjLot(
					lots,
					lot,
					langueId,
					requeteLot.requete_lot_date_debut,
					requeteLot.requete_lot_date_fin
				),
				text
			);

			const proprietaire = lot.lot_proprietaire;
			text = fusionChamps(getMapObjPro(proprietaire), text);
		}
	}

	const recherche = requete?.requete_recherche;
	if (recherche && recherche !== undefined) {
		let mapObjRec = {
			"#recherche_date_debut": formatDateToAPP(recherche.recherche_date_debut),
			"#recherche_date_fin": formatDateToAPP(recherche.recherche_date_fin),
		};
		text = fusionChamps(mapObjRec, text);
	}

	/*text += this.props.parametre.parametre_signature
		? this.props.parametre.parametre_signature
		: "";*/

	/*const content = EditorState.createWithContent(
		ContentState.createFromBlockArray(
			htmlToDraft(text, (nodeName, node) => {
				if (nodeName === "img" && node instanceof HTMLImageElement) {
					if (node.parentElement instanceof HTMLDivElement) {
						// for image with div element as a parent
						const entityConfig = {};
						const parentElement = node.parentElement;
						if (parentElement.style.float) {
							// check float style property
							entityConfig.alignment = parentElement.style.float;
						} else if (parentElement.style.textAlign) {
							// check float style property
							entityConfig.alignment = parentElement.style.textAlign;
						}

						entityConfig.src = node.getAttribute
							? node.getAttribute("src") || node.src
							: node.src;
						entityConfig.alt = node.alt;
						entityConfig.height = node.style.height;
						entityConfig.width = node.style.width;
						return {
							type: "IMAGE",
							mutability: "MUTABLE",
							data: entityConfig,
						};
					}
				}
			})
		)
	);*/

	/*this.setState({
		editorState: content,
		objet,
		templateSelected,
	});
	if (this.props.withForm) this.props.onEditorStateChange(content);*/

	return text;
}

export function onSelectTemplatePro(data, templateSelected, langueId) {

		return fusionChamps(getMapObjData(data), templateSelected);
}

